import { render, staticRenderFns } from "./mai.vue?vue&type=template&id=64ef044a&scoped=true"
import script from "./mai.vue?vue&type=script&lang=ts"
export * from "./mai.vue?vue&type=script&lang=ts"
import style0 from "./mai.vue?vue&type=style&index=0&id=64ef044a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef044a",
  null
  
)

export default component.exports